// extracted by mini-css-extract-plugin
module.exports = {"authLanding":"styles_authLanding__32Vdm"};